import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React, { forwardRef, useRef, useEffect, useLayoutEffect } from "react";

import SSRIcon from "@ingka/ssr-icon";
import chevronDownSmallIcon from "@ingka/ssr-icon/paths/chevron-down-small";
import { Divider } from "./Divider.mjs";
import { updateWidth } from "@ingka/search-shared";
const SearchScope = forwardRef(({ prefix, options, selectProps = {} }, ref) => {
  const baseClass = `${prefix}search`;
  const selectRef = useRef();
  ref.current = selectRef.current;
  useEffect(() => {
    updateWidth(selectRef.current);
  }, []);
  useLayoutEffect(() => {
    updateWidth(selectRef.current);
  }, [options, selectProps.selectedIndex || -1]);
  function handleChange(ev) {
    updateWidth(selectRef.current);
    if (selectProps && selectProps.onChange)
      selectProps.onChange(ev);
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Divider, { baseClass }),
    /* @__PURE__ */ jsx(
      "select",
      {
        ref: selectRef,
        className: `${baseClass}__scope`,
        ...selectProps,
        onChange: handleChange,
        children: Object.keys(options).map((scopeKey, index) => /* @__PURE__ */ jsx(
          "option",
          {
            label: scopeKey,
            value: options[scopeKey]
          },
          `${scopeKey}--${index}`
        ))
      }
    ),
    /* @__PURE__ */ jsx(
      SSRIcon,
      {
        className: `${baseClass}__chevron-down`,
        prefix,
        paths: chevronDownSmallIcon
      }
    )
  ] });
});
export {
  SearchScope
};
